import React from 'react';
import { Button } from '@/components/ui/button';

/**
 * StarBorder Button Component - dari ReactBits
 * https://reactbits.dev/animations/star-border
 * 
 * Button dengan animasi cahaya bintang bergerak di border
 */
const StarBorderButton = ({
  children,
  onClick,
  className = '',
  color = 'cyan',
  speed = '5s',
  variant = 'default',
  size = 'default',
  type = 'button',
  disabled = false,
  ...rest
}) => {
  // Convert color name to actual color value
  const getColorValue = (colorName) => {
    const colors = {
      cyan: 'rgb(6, 182, 212)', // cyan-500
      blue: 'rgb(59, 130, 246)', // blue-500
      purple: 'rgb(168, 85, 247)', // purple-500
      pink: 'rgb(236, 72, 153)', // pink-500
      white: 'rgb(255, 255, 255)',
    };
    return colors[colorName] || colors.cyan;
  };

  const colorValue = getColorValue(color);

  return (
    <div
      className="relative inline-block overflow-hidden rounded-[20px] p-[1px]"
      {...rest}
    >
      {/* Bottom star - moves from right to left */}
      <div
        className="absolute w-[300%] h-[50%] opacity-70 bottom-[-11px] right-[-250%] rounded-full animate-star-movement-bottom"
        style={{
          background: `radial-gradient(circle, ${colorValue}, transparent 10%)`,
          animationDuration: speed,
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />
      
      {/* Top star - moves from left to right */}
      <div
        className="absolute w-[300%] h-[50%] opacity-70 top-[-10px] left-[-250%] rounded-full animate-star-movement-top"
        style={{
          background: `radial-gradient(circle, ${colorValue}, transparent 10%)`,
          animationDuration: speed,
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />
      
      {/* Button with content - preserves all original styling */}
      <Button
        onClick={onClick}
        type={type}
        disabled={disabled}
        variant={variant}
        size={size}
        className={`relative rounded-[19px] ${className}`}
        style={{ zIndex: 1 }}
      >
        {children}
      </Button>
    </div>
  );
};

export default StarBorderButton;
